<template>
    <div class="" :class="[ type == 'login-page' ? 'sign-form' : 'checkout-panel-container' ]">
        <default-login @set="setUser" />
        <span class="register-line register-forgot">
            <a :href="globalVariables.locale + '/forgot-password'">
               {{ trans('passwords.forgot_password') }}
            </a> |
            <a :href="globalVariables.locale + '/register'">
                {{ trans('pages.register_account') }}
            </a>
        </span>
        <span v-if="sms_login" class="if-separator">
            <span class="text">{{ trans('auth.or') }}</span>
        </span>
        <div v-if="sms_login" class="checkout-panel-column">
            <phone-login :type="type" @set="setUser" />
        </div>
    </div>
</template>

<script>
import defaultLogin from "./login/Default";
import phoneLogin from "./login/Phone";

export default {
    props: {
        type: {
            required: false,
            default: null
        },
        sms_login: {
            required: false,
            default: null
        }
    },
    components: {
        "default-login": defaultLogin,
        "phone-login": phoneLogin
    },
    methods: {
        setUser(data) {
            this.$store.commit('user_data', data.user);
            if (data.user_additional) {
                this.$store.commit('user_additional_data', data.user_additional);
            }
            if (this.type == "login-page") {
                window.location.href = data.intended_url;
            }
        }
    }
}
</script>